import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
  selector: 'core-block-client-home-banner',
  templateUrl: './block-home-banner.component.html',
  standalone: false,
})
export class BlockHomeBannerComponent extends BlockAbstractComponent implements OnInit {
  backgroundImage!: string;

  override ngOnInit() {
    super.ngOnInit();
    this.backgroundImage = this.block.data.image_url;
  }

  getInterval(): number {
    return this.block.data.options.intervalSpeed ? parseInt(this.block.data.options.intervalSpeed) : 3000;
  }
}
